module.exports = __webpack_public_path__ + "fonts/Vonnes-LightComp.dde71c28.otf";